<template>
	<div class="dynamiclist qualityenterprise">
		<leftnav class="fl" mkcode="B" itemcode="B-DTJC"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">监测企业</span>
						<video-teaching :type="2" seat="top"></video-teaching>
					</div>
					<div class="opport-screen-list1">
						<dl class="opport-screen-nbg bdbe">
							<dt class="fl title">已选企业</dt>
							<dd>
								<span v-for="item in enterpriseOption" v-show="item.investId > 0"
									@click="investIdtoggle('a', item)" class="reomvescreen bdrf">{{ item.title }}
									<em>—</em></span>
							</dd>
						</dl>
						<div class="eninvest_list_screen oh">
							<h5 class="fl title">企业名称</h5>
							<!-- 	<div class="fl"> -->
							<input type="text" placeholder="请输入企业名称" class="searchinput bdrf" v-model="searchtext"
								@keydown="searchenter" />
							<!-- </div> -->
							<button class="basebtn bdrf" @click="searchkwfun">查询</button>
						</div>


					</div>
				</div>
				<div class="whitebox" style="min-height:560px;">
					<div class="enterparise_guide oh" style="width: 95%; " v-show="kwtextsearch">
						<p class="fl" style="width: 95%;">产业大脑为您找到<span class="searchnum">{{ total }}</span>条【 <span
								class="orangefont">{{ kwtextsearchtext }}</span>】相关结果</p>
					</div>
					<div class="enterprise_list_box" v-show="total > 0">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list, index) in enterpirselist">
								<td>{{ (page - 1) * pageSize + index + 1 }}</td>
								<td class="title" @click="routerlinkid('/enterprises', list.stockCode, curindex)">
									{{ list.title }}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.notionlist"
										@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'quality1')">{{ item.name }}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" v-for="item in list.taglist"
										@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name, 'quality1')">{{ item.name }}</span>
								</td>
								<td>{{ list.area }}</td>
								<td>{{ list.zs100000 }}</td>
								<td class="collectfont1"><span
										@click="investIdtoggle('b', list)">{{ list.investId > 0 ? '移除' : '添加' }} </span></td>
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'landdynamic',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data: function () {
		return {
			userdata: {}, title: '添加企业',
			searchtype: 2, enterpriseOption: [], enterpirselist: [],
			searchtext: "",
			kwtextsearch: false,
			kwtextsearchtext: "",
			showscreen: true,
			page: 1, //显示的是哪一页 
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
		};
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
		// this.bus.$emit('loading', true);
	},

	mounted() {
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.getenterOption();
		this.bus.$emit('loading', true);
	},
	methods: {
		//获取用户设置的企业列表数据
		getenterOption() {
			var _this = this;
			var ajaxurl = this.$api.cyl.userenterprise.list();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log(ajaxurl)
				console.log('获取用户设置的企业列表数据', res.data.list)
				if (res.data.success) {
					_this.enterpriseOption = res.data.list;
					_this.enterpriseOption.forEach(list => {
						list.investId = list.id;
					})
					_this.bus.$emit('loading', false);
					// _this.enterpriseOption.unshift({id:0,title:'全部',stockCode:"all"})
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取搜索后企业列表
		getsearchCompany(page) {
			this.bus.$emit('loading', true);
			this.page = page ? page : '1';
			var kwa = this.splicing('kw', this.searchtext);
			var _this = this;
			this.$axios.get(this.$api.cyl.enterprise.list() + '?type=0&page=' + this.page + kwa, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('获取搜索后企业列表', res.data.list);
				if (res.data.success) {
					var dataenterlist = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						var ddd = dataenterlist[i].financingRound;
						dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode);
						dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);
						dataenterlist[i].investId = 0;
						for (var d = 0; d < _this.enterpriseOption.length; d++) {
							if (_this.enterpriseOption[d].stockCode == dataenterlist[i].stockCode) {
								dataenterlist[i].investId = _this.enterpriseOption[d].id;
							}
						}
					}
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.kwtextsearch = _this.searchtext != "";
					_this.kwtextsearchtext = _this.searchtext;
					_this.enterpirselist = dataenterlist;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//移除/增加已选企业
		investIdtoggle(type, listd) {
			var _this = this, datad = {}, ajaxurl = '';
			var id = listd.investId;
			if (id > 0) {
				datad = { id: id }; ajaxurl = this.$api.cyl.userenterprise.remove();
				// var res={data:{id:0}};
			} else {
				datad = { stockCode: listd.stockCode }; ajaxurl = this.$api.cyl.userenterprise.add();
				// var res={data:{id:8}};
			}
			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: datad,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					if (res.success) {
						console.log(res);
						if (id > 0) {
							_this.enterpriseOption = _this.enterpriseOption.filter(list => {
								return list.investId != listd.investId;
							});
							_this.enterpirselist.forEach(list => {
								if (listd.stockCode == list.stockCode) {
									list.investId = 0;
								}
							})
						} else {
							listd.investId = res.data.id;
							_this.enterpriseOption.push({ title: listd.title, id: res.data.id, investId: res.data.id, stockCode: listd.stockCode })
						}
					}
				}
			})
		},
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.getsearchCompany(1, 'search');
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		pageHandler: function (page) {
			this.page = page;
			this.getsearchCompany(page);
		},
	}
}
</script>

<style>@import url("../../css/index-continue.css");</style>